import { FLOW_QUESTION_FIELD_TYPE, SIMPLE_FIELD_TYPE } from "../utils/const";
import { mapActions, mapGetters } from "vuex";
import { formatDateTime } from "../utils/util";

export default {
  computed: {
    ...mapGetters({
      simpleFieldGetter: "simpleFieldStore/get",
    }),
  },
  methods: {
    ...mapActions({
      fetchSimpleField: "simpleFieldStore/fetchOne",
    }),
    async createFields() {
      for (let s in this.steps) {
        for (let q in this.steps[s].questions) {
          let question = this.steps[s].questions[q];
          if (question.fieldType === FLOW_QUESTION_FIELD_TYPE.SIMPLE_FIELD) {
            let qData = this.simpleFieldGetter(question.fieldId);
            if (!qData) {
              await this.fetchSimpleField(question.fieldId);
            }
          }
        }
      }

      let fields = [];
      for (let s in this.steps) {
        let step = this.steps[s];
        for (let q in step.questions) {
          let question = this.steps[s].questions[q];
          if (question.fieldType === FLOW_QUESTION_FIELD_TYPE.SIMPLE_FIELD) {
            let qData = this.simpleFieldGetter(question.fieldId);
            if (qData) {
              let answer = this.$store.getters[
                "application/getFlowQuestionAnswer"
              ](qData.identifier);
              if (answer) {
                if (
                  qData.type === SIMPLE_FIELD_TYPE.CHECKBOX ||
                  qData.type === SIMPLE_FIELD_TYPE.RADIO ||
                  qData.type === SIMPLE_FIELD_TYPE.SELECT
                ) {
                  if (answer.startsWith("[")) {
                    answer = answer.replace("[", "");
                    answer = answer.replace("]", "");
                    answer = answer.replaceAll(/\"/g, "");
                    answer = answer.replaceAll(/\s/g, "");
                    answer = answer.split(",");
                    let multiAnswer = [];
                    for (let a in answer) {
                      for (let i in qData.inputValues) {
                        if (qData.inputValues[i].value === answer[a]) {
                          multiAnswer.push(qData.inputValues[i].text);
                          break;
                        }
                      }
                    }
                    answer = multiAnswer.join("; ");
                  } else {
                    for (let i in qData.inputValues) {
                      if (qData.inputValues[i].value === answer) {
                        answer = qData.inputValues[i].text;
                        break;
                      }
                    }
                  }
                }
              }
              if (qData.type === SIMPLE_FIELD_TYPE.DATE_PICKER) {
                answer = formatDateTime(answer);
              }
              if (answer) {
                fields.push({
                  question: qData.label,
                  answer: answer,
                  identifier: qData.identifier,
                  index: step.rowIndex * 1000 + question.rowIndex,
                });
              }
            }
          }
        }
      }
      fields = fields.sort((a, b) => a.index - b.index);
      return fields;
    },
  },
};
